import React, {useEffect, useState, useRef} from 'react';
//components
import View from './meetings-view';
//utils
import {OrganisationService} from '../../../utils/data-transfer'

const MeetingsContainer = (props) => {
  const organisationService = useRef(new OrganisationService());
  const [state, setState] = useState({
    isLoading: true,
    meetings: []
  });

  useEffect(() => {
    const bootstrapComponent = async ( ) => {
      const meetings = await organisationService.current.getMeetings();

      setState(prevState => ({...prevState, meetings, isLoading: false}));
    };

    bootstrapComponent();
  }, []);

  return (
    <View
      {...state}/>
  );
};

export default MeetingsContainer;